export default "__VITE_ASSET__h8_JhDoQ__"